// extracted by mini-css-extract-plugin
export default {"errorContainer":"ServerError_errorContainer__5qiZu","errorCode":"ServerError_errorCode__UDrSz","errorMessage":"ServerError_errorMessage__HsUk9"};